import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListUl } from '@fortawesome/free-solid-svg-icons';

import './agenda.css';

const Agenda = () => {
  return (
    <div className="giswnauce__agenda">
        <div className="giswnauce__agenda-container">
            <span className="anchor-agenda" id="giswnauce_agenda"></span>
            <div className="agenda-container_header">
                <p><FontAwesomeIcon icon={faListUl} /></p><h1>Program Konferencji</h1>
            </div>
            <div className="agenda-container_subheader">
                <h2>24 września 2026 (Dzień 1)</h2>
            </div>
            <div className="agenda-container_description first_table">
                <table>
                    <thead>
                        <tr>
                            <th>Godziny</th>
                            <th>Element konferencji</th>
                            <th>Czas trwania</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>08:15 - 09:00</td>
                            <td>Rejestracja uczestników</td>
                            <td>45 min</td>
                        </tr>
                        <tr>
                            <td>09:00 - 10:00</td>
                            <td>Sesja inauguracyjna</td>
                            <td>60 min</td>
                        </tr>
                        <tr>
                            <td>10:00 - 11:30</td>
                            <td>Sesja tematyczna 1</td>
                            <td>90 min</td>
                        </tr>
                        <tr>
                            <td>11:30 - 11:45</td>
                            <td>Przerwa kawowa</td>
                            <td>15 min</td>
                        </tr>
                        <tr>
                            <td>11:45 - 13:15</td>
                            <td>Sesje tematyczne 2</td>
                            <td>90 min</td>
                        </tr>
                        <tr>
                            <td>13:15 - 14:15</td>
                            <td>Obiad</td>
                            <td>60 min</td>
                        </tr>
                        <tr>
                            <td>14:15 - 15:00</td>
                            <td>Sesja posterowa połączona z przerwą kawową</td>
                            <td>45 min</td>
                        </tr>
                        <tr>
                            <td>15:00 - 16:30</td>
                            <td>Sesja tematyczna 3</td>
                            <td>90 min</td>
                        </tr>
                        <tr>
                            <th colSpan="3">Po konferencji</th>
                        </tr>
                        <tr>
                            <td>20:00 - 24:00</td>
                            <td>Uroczysta kolacja</td>
                            <td>4 godziny</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="agenda-container_subheader">
                <h2>25 września 2026 (Dzień 2)</h2>
            </div>
            <div className="agenda-container_description second_table">
            <table>
                    <thead>
                        <tr>
                            <th>Godziny</th>
                            <th>Element konferencji</th>
                            <th>Czas trwania</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>09:00 - 10:30</td>
                            <td>Sesja tematyczna 4</td>
                            <td>90 min</td>
                        </tr>
                        <tr>
                            <td>10:30 - 10:45</td>
                            <td>Przerwa kawowa</td>
                            <td>15 min</td>
                        </tr>
                        <tr>
                            <td>10:45 - 12:15</td>
                            <td>Sesje tematyczna 5</td>
                            <td>90 min</td>
                        </tr>
                        <tr>
                            <td>12:15 - 12:30</td>
                            <td>Przerwa kawowa</td>
                            <td>15 min</td>
                        </tr>
                        <tr>
                            <td>12:30 - 13:30</td>
                            <td>Sesje tematyczna 6</td>
                            <td>60 min</td>
                        </tr>
                        <tr>
                            <td>13:30 - 14:30</td>
                            <td>Obiad</td>
                            <td>60 min</td>
                        </tr>
                        <tr>
                            <td>14:30 - 15:45</td>
                            <td>Panel dyskusyjny: <span style={{fontStyle: 'italic'}}>GIS i rynek pracy – czego pracodawcy oczekują od absolwentów?</span></td>
                            <td>75 min</td>
                        </tr>
                        <tr>
                            <td>15:45</td>
                            <td>Podsumowanie, wyróżnienie najciekawszych referatów i posterów oraz zakończenie konferencji</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p>
                Panel dyskusyjny – do debaty przystąpią przedstawiciele środowiska akademickiego, biznesu, administracji publicznej oraz studenci, aby wspólnie odpowiedzieć na pytanie, jakie kompetencje są dziś kluczowe na rynku pracy związanym z GIS. Dyskusja będzie okazją do wymiany doświadczeń, poznania perspektywy pracodawców oraz zidentyfikowania wyzwań stojących przed kształceniem przyszłych specjalistów. Panel organizowany jest w ramach ChallengeEU M.A.R.K.E.T. Student Activity, promującej współpracę między uczelniami oraz interesariuszami zewnętrznymi.
            </p>
        </div> 
    </div>
  )
}

export default Agenda